import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-guest-confirmation',
  templateUrl: './guest-confirmation.component.html',
  styleUrls: ['./guest-confirmation.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class GuestConfirmationComponent implements OnInit, OnDestroy {
  constructor() {}

  ngOnInit() {
    document.body.style.margin = '0';
    document.body.style.padding = '0';
    document.body.style.overflow = 'hidden';
  }

  ngOnDestroy() {
    document.body.style.margin = '';
    document.body.style.padding = '';
    document.body.style.overflow = '';
  }
}
